import React from 'react';
import AdminLoginComponent from '../components/admin/Login';

const AdminLogin: React.FC = () => {
  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-main-dark p-5">
      <AdminLoginComponent />
    </div>
  );
};

export default AdminLogin;
